module.exports = __webpack_public_path__ + "324ba19b1201de8fcf8877a0f40216f0.svg";